import { apiClient } from './client';
import type { SimPlan } from '@/types/oscar';

/** Search SIM plans (oscar.SimPlan) by name / carrier. Backs the line-item picker. */
export function searchSimPlans(q: string, signal?: AbortSignal): Promise<SimPlan[]> {
  return apiClient.get<SimPlan[]>(`/api/sim-plans?q=${encodeURIComponent(q)}`, signal);
}
